/**
 * Miniatura de mídia anexada na mensagem de follow-up.
 */
import React from 'react';
import { X, File, Film, Mic } from 'lucide-react';
import { fileNameFromUrl, guessMediaKind } from '../followUpMedia';

export default function FollowUpMediaPreview({
    url,
    onRemove,
}: {
    url: string;
    onRemove: () => void;
}) {
    const kind = guessMediaKind(url);
    const name = fileNameFromUrl(url);

    return (
        <article className="relative w-28 shrink-0 overflow-hidden rounded-lg border border-border bg-surface-subtle sm:w-32">
            <button
                type="button"
                onClick={onRemove}
                className="absolute right-s1 top-s1 z-10 inline-flex size-8 touch-manipulation items-center justify-center rounded-full bg-surface/90 text-secondary shadow-sm ring-1 ring-border hover:text-default md:size-6"
                aria-label={`Remover ${name}`}
            >
                <X className="size-3.5" aria-hidden="true" />
            </button>

            {kind === 'image' && (
                <img src={url} alt={name} className="aspect-square w-full object-cover" loading="lazy" />
            )}

            {kind === 'video' && (
                <div className="relative aspect-square w-full bg-surface">
                    <video src={url} className="size-full object-cover" muted playsInline preload="metadata" />
                    <span className="pointer-events-none absolute inset-0 flex items-center justify-center bg-black/25">
                        <Film className="size-6 text-white" aria-hidden="true" />
                    </span>
                </div>
            )}

            {kind === 'audio' && (
                <div className="flex aspect-square flex-col items-center justify-center gap-s2 p-s2">
                    <span className="inline-flex size-10 items-center justify-center rounded-full bg-warning/15 text-warning">
                        <Mic className="size-5" aria-hidden="true" />
                    </span>
                    <p className="line-clamp-2 w-full text-center text-xs text-secondary" title={name}>{name}</p>
                </div>
            )}

            {kind === 'document' && (
                <div className="flex aspect-square flex-col items-center justify-center gap-s2 p-s2">
                    <span className="inline-flex size-10 items-center justify-center rounded-full bg-info/15 text-info">
                        <File className="size-5" aria-hidden="true" />
                    </span>
                    <p className="line-clamp-2 w-full text-center text-xs text-secondary" title={name}>{name}</p>
                </div>
            )}
        </article>
    );
}
